// ============================================================
// PANEL SAYFA REHBERI
//
// Her panel sayfasinin ustunde gorunen aciklama kartinin icerigi.
// Amac: kullanici hangi sayfada oldugunu, o sayfanin UYGULAMADA
// NEREYE denk geldigini ve her alanin ne ise yaradigini panelden
// ayrilmadan gorebilsin.
//
// Kart bileseni: components/Common/SayfaRehberi.js
// Ayrintili anlatim (musteriye verilen surum): public/kilavuz.html
//
// Yeni sayfa eklenince buraya da bir kayit ekleyin; kayit yoksa
// kart hic cizilmez, sayfa eskisi gibi calisir.
// ============================================================

const REHBER = {
  slider: {
    ozet: "Ana sayfanın en üstünde kayan görselleri yönetir.",
    nerede: "Uygulama → Ana sayfa, en üstteki büyük kayan alan",
    alanlar: [
      ["Görsel", "Kayan alanda görünen resim veya video. Yatay (geniş) görseller daha iyi durur."],
      ["Başlık", "Zorunlu değildir. Yalnızca panelde kaydı tanımanız için kullanılır."],
      ["Sıralama", "Görsellerin dönme sırası. Küçük sayı önce gösterilir."],
      ["Link", "Dış bir siteye götürür. DOLU İSE aşağıdaki bütün seçimler geçersiz olur; http:// veya https:// ile başlamalıdır."],
      ["Haber / Forum / İlan / Anasayfa Kategori Seçiniz", "Uygulama içinde gidilecek yer. Yalnızca biri seçilebilir; birini seçtiğinizde diğerleri kendiliğinden temizlenir."],
      ["Spora Yönlendir?", "Açıksa dokunulunca Spor sayfası açılır (Süper Lig, 1. Lig, Sonuçlar, Gelecek, Berlin sekmeleri)."],
      ["Slider Kategori Seçiniz", "Slider'ın türü. Normal ana sayfa slider'ı için değiştirmeyin."],
      ["Aktif Mi?", "Kapalıysa slider uygulamada hiç görünmez. Silmek yerine bunu kullanın."],
    ],
    ipuclari: [
      "Formun üstündeki mavi bantta \"Tıklanınca gidilecek yer\" yazar; kaydetmeden önce oraya bakın.",
      "Seçtiğiniz hedefi geri almak için listenin en üstündeki boş seçeneği seçin.",
    ],
    uyari: "Link kutusu doluyken hiçbir uygulama içi yönlendirme çalışmaz.",
  },

  news: {
    ozet: "Aktüel (haber) içeriklerini yönetir.",
    nerede: "Uygulama → Aktüel bölümü: haber listesi ve haber detay sayfası",
    alanlar: [
      ["Kategori Seçiniz", "Haberin hangi sekmede görüneceği."],
      ["Başlık", "Listede ve bildirimde görünen isim."],
      ["Kısa Açıklama", "Liste görünümünde başlığın altındaki iki satır."],
      ["Görsel", "Liste kartının ve detay sayfasının kapak resmi."],
      ["Uzun Açıklama", "Haberin gövdesi. Metin editörüyle yazılır; Word'den yapıştırma desteklenir."],
      ["Aktif Mi?", "Kapalıysa haber uygulamada görünmez."],
    ],
    ipuclari: [
      "Kapak görseli yüklenmemiş haberler listede boş kutu olarak görünür.",
      "Yazının içine eklediğiniz görseller kapak görselinin yerini tutmaz; ikisini de verin.",
    ],
  },

  newscategory: {
    ozet: "Aktüel bölümünün üst kısmındaki kategori sekmelerini yönetir.",
    nerede: "Uygulama → Aktüel bölümünün en üstündeki sekmeler",
    alanlar: [
      ["Başlık", "Sekmede yazan isim."],
      ["Görsel", "Kategori kartının resmi."],
      ["Uzun Açıklama", "Kategorinin tanıtım metni."],
    ],
    uyari: "Kategori kayıtlarını silmeyin; bölümler bunlara bağlıdır. Görünmesini istemiyorsanız pasife alın.",
  },

  mainpagecategory: {
    ozet: "Ana sayfadaki bölüm kartlarını yönetir (Berlin İş Rehberi, Medya Aktüel, Söz Sizde gibi).",
    nerede: "Uygulama → Ana sayfa, slider'ın altındaki kartlar",
    alanlar: [
      ["Başlık", "Kartın üstünde yazan isim."],
      ["Görsel", "Kart görseli."],
      ["Sıralama", "Kartların ana sayfadaki sırası. Küçük sayı önce."],
      ["Açıklama", "Kartın altındaki kısa tanıtım."],
      ["Uzun Açıklama / Uzun Açıklama 2", "Bölüme girildiğinde görünen tanıtım metinleri."],
      ["Aktif Mi?", "Kapalıysa kart ana sayfada görünmez."],
    ],
    uyari: "Bu kayıtların bazıları uygulamanın özel sayfalarını besler. Silmeyin, gerekiyorsa pasife alın.",
  },

  company: {
    ozet: "Firma rehberindeki işletme kayıtlarını yönetir.",
    nerede: "Uygulama → Rehber bölümü: firma listesi, firma detay sayfası ve harita",
    alanlar: [
      ["Rehber Alt Kategori Seçiniz", "Firmanın hangi kategori altında listeleneceği."],
      ["Kullanıcı Seçiniz", "Firmayı yönetecek kullanıcı hesabı."],
      ["Başlık", "Firma adı."],
      ["Açıklama", "Firma detay sayfasındaki tanıtım metni."],
      ["Telefon / WhatsApp Numarası", "Detay sayfasındaki arama ve WhatsApp düğmeleri."],
      ["Web Site / Mail Adresi", "Detay sayfasındaki bağlantılar."],
      ["Çalışma Saatleri", "Detay sayfasında gösterilir."],
      ["Adres", "Detay sayfasında yazan açık adres."],
      ["Enlem / Boylam", "Firmanın haritadaki konumu. Boş bırakılırsa firma haritada görünmez."],
      ["Sıralama", "Liste içindeki sıra. Küçük sayı önce."],
      ["Görsel", "Firma logosu / kapak resmi."],
      ["Aktif Mi?", "Kapalıysa firma rehberde görünmez."],
      ["Rehber reklam alanında görünsün mü?", "Firma, rehberin öne çıkan (vitrin) alanında da gösterilir."],
      ["Ücretli mi?", "Firmanın ücretli paketi olup olmadığı."],
    ],
    ipuclari: [
      "Enlem/Boylam: Google Haritalar'da konuma sağ tıklayın; çıkan iki sayıdan ilki Enlem, ikincisi Boylam'dır.",
    ],
  },

  companycategory: {
    ozet: "Firma rehberinin ana kategorilerini yönetir.",
    nerede: "Uygulama → Rehber bölümünün kategori listesi",
    alanlar: [["Rehber Kategorisi", "Kategori adı."], ["Görsel", "Kategori simgesi / resmi."]],
  },

  companysubcategory: {
    ozet: "Firma rehberinin alt kategorilerini yönetir.",
    nerede: "Uygulama → Rehber → bir kategoriye girildiğinde çıkan alt başlıklar",
    alanlar: [
      ["Kategorisi Seçiniz", "Bu alt kategorinin bağlı olduğu ana kategori."],
      ["Başlık", "Alt kategori adı."],
      ["Görsel", "Alt kategori resmi."],
    ],
  },

  companyadvertprice: {
    ozet: "Firmaların ilanlarını öne çıkarmak için satın aldığı görsel paketlerin ücretlerini belirler.",
    nerede: "Uygulama → Rehber/İlan bölümünde firmanın satın alma ekranı",
    alanlar: [
      ["Background Ücret", "İlan kartının arka plan rengini değiştirme ücreti."],
      ["Başlık Renk Ücret", "Başlık rengini değiştirme ücreti."],
      ["Border Ücret", "Kart çerçevesi ücreti."],
      ["Font Ücret", "Yazı tipi değiştirme ücreti."],
      ["link Ücret", "İlana bağlantı ekleme ücreti."],
      ["Açıklama Ücret", "Ek açıklama alanı ücreti."],
    ],
  },

  jobadvertisement: {
    ozet: "İlan bölümündeki ilanları yönetir. İlanların çoğunu kullanıcılar uygulamadan açar.",
    nerede: "Uygulama → İlanlar bölümü: ilan listesi ve ilan detay sayfası",
    alanlar: [
      ["İlan Görselleri", "İlan detayında kaydırılan fotoğraflar."],
      ["Açıklama", "İlan metni."],
      ["İlan Sahibi / Telefon", "İlanı veren kişi ve iletişim numarası."],
      ["Adres", "İlanın konumu."],
      ["Görüntülenme / Beğeni", "İlanın aldığı ilgi. Bilgi amaçlıdır."],
      ["Aktif Mi?", "Kapalıysa ilan uygulamada görünmez."],
    ],
    ipuclari: ["Kullanıcıların açtığı yeni ilanlar önce Onay Bekleyenler sayfasına düşer."],
  },

  jobadvertisementcategory: {
    ozet: "İlan bölümünün ana kategorilerini yönetir.",
    nerede: "Uygulama → İlanlar bölümünün kategori listesi",
    alanlar: [["İLAN Kategorisi", "Kategori adı."]],
  },

  jobadvertisementsubcategory: {
    ozet: "İlan bölümünün alt kategorilerini yönetir.",
    nerede: "Uygulama → İlanlar → kategori içindeki alt başlıklar",
    alanlar: [
      ["Kategorisi Seçiniz", "Bağlı olduğu ana kategori."],
      ["Başlık", "Alt kategori adı."],
      ["Görsel", "Alt kategori resmi."],
    ],
  },

  forum: {
    ozet: "\"Bir Bilen\" bölümündeki konuları yönetir. Konuları kullanıcılar açar.",
    nerede: "Uygulama → Bir Bilen bölümü",
    alanlar: [
      ["Görsel", "Konu kartının resmi."],
      ["Aktif Mi?", "Kapalıysa konu uygulamada görünmez."],
    ],
    ipuclari: ["Yeni konular ve yorumlar Onay Bekleyenler sayfasından onaylanır."],
  },

  articleday: {
    ozet: "\"Söz Sizde\" ve \"Esnaf Aktüel\" yazılarını yönetir.",
    nerede: "Uygulama → Ana sayfadaki Söz Sizde ve Esnaf Aktüel bölümleri",
    alanlar: [
      ["Bölüm", "Yazının Söz Sizde'de mi Esnaf Aktüel'de mi çıkacağı."],
      ["Kullanıcı Seçiniz", "Yazının sahibi."],
      ["Başlık", "Listede görünen isim."],
      ["Kısa Açıklama", "Liste görünümündeki özet."],
      ["Uzun Açıklama", "Yazının gövdesi."],
      ["Görsel", "Kapak resmi."],
    ],
    uyari: "Bölüm alanı yanlış seçilirse yazı beklediğiniz yerde değil, diğer bölümde çıkar.",
  },

  advertesingform: {
    ozet: "Bölüm içi reklamları yönetir: ana sayfa kartlarının altındaki ve bölüm ekranlarındaki reklamlar.",
    nerede: "Uygulama → Ana sayfa kart altları ve bölüm ekranları (Alan No'ya göre değişir)",
    alanlar: [
      ["Reklam Alanı Seçiniz (Alan No)", "Reklamın uygulamada NEREDE çıkacağını belirleyen alan. Seçince altında o alanın hangi ekranda göründüğü yazar."],
      ["Görsel / Video", "Reklamın kendisi."],
      ["Başlık", "Panelde kaydı tanımanız için."],
      ["Sıra No (gösterim sırası)", "Aynı alanda birden fazla reklam varsa gösterim sırası."],
      ["Yükseklik (reklam alanı)", "Reklamın uygulamadaki yüksekliği. Boş bırakılırsa varsayılan kullanılır."],
      ["Yönlendirme Linki", "Dokununca gidilecek dış site."],
      ["Haber / Forum / İlan Seçiniz", "Dokununca gidilecek uygulama içi içerik."],
      ["Türü", "Özel sayfaya yönlendirir: döviz, tatil, eczane, imsakiye, lotto, map, spor. Boşsa reklam sadece görsel olarak durur."],
      ["Aktif Mi?", "Kapalıysa reklam görünmez."],
    ],
    uyari: "11 ve 12 numaralı alanlar şu an uygulamada kullanılmıyor; buraya girilen reklam görünmez.",
  },

  advertesingcategory: {
    ozet: "Reklam alanlarının isim listesidir.",
    nerede: "Doğrudan görünmez; reklam alanı numaraları bu kayıtlara bağlıdır",
    alanlar: [["Reklam Kategorisi", "Alan adı."], ["Görsel", "Panelde tanıma amaçlı."]],
    uyari: "Buradaki kayıtları silmeyin veya adlarını değiştirmeyin; reklamların uygulamada nereye düşeceği bu adlara göre belirlenir.",
  },

  PopupList: {
    ozet: "Ana sayfadaki reklam panosunu ve liste satır aralarına giren reklamları yönetir.",
    nerede: "Uygulama → Ana sayfada hava durumunun altındaki pano; ilan ve rehber listelerinde satır araları",
    alanlar: [
      ["Görsel", "Reklamın kendisi."],
      ["Başlık", "Panoda görselin üstünde görünen firma adı rozeti."],
      ["Link", "Dokununca gidilecek adres."],
      ["Reklam Gösterim Tipi", "Reklamın hangi listede/panoda çıkacağı."],
      ["Yükseklik (Anasayfa reklam panosu)", "Panonun yüksekliği."],
      ["Pozisyon Sırası", "Panodaki sıra. Küçük sayı önce."],
    ],
  },

  dinamikForm: {
    ozet: "Ana sayfadaki anketi yönetir.",
    nerede: "Uygulama → Ana sayfadaki anket kutusu",
    alanlar: [
      ["Anket Adı", "Anket başlığı / sorusu."],
      ["Anasayfa Kategorisi Seçiniz", "Anketin bağlı olduğu bölüm."],
      ["Görsel", "Anket görseli."],
      ["Aktif Mi?", "Kapalıysa anket görünmez."],
    ],
    ipuclari: ["Aktüel bölümündeki anket ayrı bir sayfadan yönetilir: Anket (Aktüel)."],
  },

  poolaktuel: {
    ozet: "Aktüel bölümündeki anketi yönetir.",
    nerede: "Uygulama → Aktüel bölümündeki anket",
    alanlar: [
      ["Bölüm", "Anketin görüneceği aktüel kategorisi."],
      ["Soru", "Kullanıcıya sorulan soru."],
      ["Cevaplar (en az 2)", "Seçenekler. En az iki seçenek girilmelidir."],
    ],
  },

  song: {
    ozet: "Müzik bölümündeki şarkıları yönetir.",
    nerede: "Uygulama → Müzik bölümü (Android)",
    alanlar: [
      ["Şarkı Kategori Seçiniz", "Şarkının listesi."],
      ["Başlık / Artist", "Şarkı adı ve sanatçı."],
      ["Şarkı Süresi", "Çalar üzerinde görünen süre."],
      ["Şarkı", "Ses dosyası."],
      ["Görsel", "Kapak resmi."],
      ["Uzun Açıklama", "Şarkı hakkında metin."],
    ],
  },

  songcategory: {
    ozet: "Müzik bölümünün listelerini yönetir.",
    nerede: "Uygulama → Müzik bölümünün kategori listesi",
    alanlar: [["Başlık", "Liste adı."], ["Görsel", "Liste kapağı."]],
  },

  berlinamatorlig: {
    ozet: "Spor sayfasının Berlin sekmesinde görünen amatör kulüpleri yönetir.",
    nerede: "Uygulama → Spor sayfası → Berlin sekmesi, en üstteki kulüp rozetleri",
    alanlar: [
      ["Takım Adı", "Rozetin üstünde yazan isim."],
      ["fussball.de Kulüp Kimliği", "Maç ve puan verisinin çekildiği anahtar. fussball.de'de kulüp sayfasını açın; adreste /-/id/ ifadesinden sonra gelen uzun kodu yapıştırın."],
      ["Sıra", "Rozetlerin soldan sağa dizilişi. Küçük sayı önce."],
      ["Uygulamada göster", "İşareti kaldırılan kulüp listeden çıkar; silmeye gerek yoktur."],
    ],
    ipuclari: [
      "Maç sonuçları ve puan durumu otomatik gelir, elle girilmez.",
      "Kulüp kimliği sezondan sezona değişmez; bir kez girilir.",
      "Sezon başında bazı kulüplerde tek maç görünebilir; fikstür açıldıkça dolar.",
    ],
  },

  newscomment: {
    ozet: "Haberlere yazılan yorumları yönetir.",
    nerede: "Uygulama → Aktüel haber detayının altındaki yorumlar",
    alanlar: [["Başlık", "Yorum metni."]],
    uyari: "Yorumlar onaylanana kadar uygulamada görünmez. Onaylama işlemi Onay Bekleyenler sayfasından yapılır.",
  },

  moderation: {
    ozet: "Kullanıcıların gönderdiği ve onayınızı bekleyen bütün içerikleri tek yerde toplar.",
    nerede: "Onaylanan içerik ilgili bölümde anında görünür; onaylanmayan hiç görünmez",
    alanlar: [
      ["İş İlanları", "Kullanıcıların açtığı ilanlar."],
      ["Firmalar", "Rehbere eklenmek istenen firmalar."],
      ["Forum Konuları / Forum Yorumları", "Bir Bilen bölümüne gönderilenler."],
      ["Aktüel Yorumları", "Haberlere yazılan yorumlar."],
      ["Firma Yorumları", "Firmalara yazılan yorumlar."],
      ["Söz Sizde Yorumları", "Söz Sizde yazılarına gelen yorumlar."],
    ],
    ipuclari: ["Bu sayfaya günde bir kez uğramak yeterlidir; onaylanmayan içerik kullanıcının gözünde kaybolmuş sayılır."],
  },

  users: {
    ozet: "Kayıtlı kullanıcıları yönetir.",
    nerede: "Uygulama → kullanıcı girişleri, ilan ve firma sahipliği",
    alanlar: [
      ["İsim Soyisim", "Kullanıcının görünen adı."],
      ["Şifre", "Giriş şifresi."],
      ["Kullanıcı Tipi Seçiniz", "Normal kullanıcı mı, yetkili mi."],
      ["Whatsapp / Facebook / Twitter", "Profilde görünen iletişim bilgileri."],
      ["Görsel", "Profil fotoğrafı."],
      ["Aktif Mi?", "Kapalıysa kullanıcı giriş yapamaz."],
    ],
  },

  uygulamaayarlari: {
    ozet: "Uygulamanın genel ayarlarını tutar.",
    nerede: "Uygulama açılışında herkesi etkiler",
    alanlar: [
      ["Android / iOS — en düşük sürüm", "Bu sürümün altındaki kullanıcılar uygulamayı kullanamaz, güncelleme ekranı görür."],
      ["Kullanıcıya gösterilecek mesaj", "Güncelleme ekranında yazan metin."],
      ["İlan yayın süresi (gün)", "Bu süreden eski ilanlar uygulamadaki listede görünmez; kayıt silinmez, sahibi \"İlanlarım\"da görmeye devam eder. Boş veya 0 = sınır yok."],
      ["Müzik bölümü", "Kapatılırsa ana sayfadaki Müzik kartı ve yan menüdeki bağlantı gizlenir. Şarkı dosyaları sunucuda yokken bölüm açık kalmasın diye eklendi."],
    ],
    uyari: "Sürüm numarasını yanlış girmek bütün kullanıcıları güncelleme ekranında kilitler. Emin değilseniz değiştirmeyin.",
  },

  bildirimler: {
    ozet: "Kullanıcılara uygulama içi bildirim gönderir ve gönderilenleri listeler.",
    nerede: "Uygulama → sağ üstteki zil ikonu (bildirim listesi)",
    alanlar: [
      ["Alıcı", "Bildirimin kime gideceği. \"Tüm kullanıcılar\" seçilirse listedeki herkese ayrı ayrı kayıt açılır."],
      ["Başlık", "Bildirim listesinde kalın görünen satır."],
      ["Mesaj", "Başlığın altındaki açıklama."],
      ["Yönlendirme", "Bildirime dokunulunca açılacak içerik türü. Boş bırakılırsa bildirim yalnızca listede görünür, hiçbir yere gitmez."],
      ["Hangi kayıt?", "Yönlendirme seçildiyse gidilecek kaydın kendisi. Seçmeden gönderilemez."],
      ["Durum", "Kullanıcının bildirimi okuyup okumadığını gösterir."],
    ],
    ipuclari: [
      "Tüm kullanıcılara gönderim kişi sayısı kadar kayıt açar; kalabalık listede birkaç saniye sürebilir.",
      "Yanlış gönderilen bildirimi listeden silebilirsiniz; kullanıcının zilinden de kaybolur.",
    ],
    uyari: "Bu bildirim uygulamanın zil ikonunda görünür. Telefon ekranında beliren \"push\" bildirimi ayrı bir servistir ve şu an kapalıdır.",
  },


  referralreport: {
    ozet: "Kimin kaç kişiyi davet ettiğini ve referansla kaydolan üyeleri gösterir. Yalnızca rapordur, buradan kayıt değiştirilmez.",
    nerede: "Uygulama → Üyelik → Arkadaşını davet et (referans kodu)",
    alanlar: [
      ["Referans Kodu", "Davet eden kullanıcının paylaştığı kod."],
      ["Getiren Kişi", "Kodun sahibi."],
      ["Davet Sayısı", "Bu kodu kullanarak kaydolan üye sayısı."],
      ["Puan", "Davet karşılığı biriken puan."],
      ["Kullanılan Kod", "Yeni üyenin kayıt olurken girdiği kod."],
    ],
    ipuclari: ["Sayılar Users tablosundan anlık hesaplanır; ayrıca bir güncelleme yapmanız gerekmez."],
  },

  satinalmaraporu: {
    ozet: "Öne çıkan ilan ve rehber reklamı satın almalarını, aylık dağılımını ve tahmini geliri gösterir. Yalnızca rapordur.",
    nerede: "Uygulama → İlan ver / Rehber kaydı ekranlarındaki ücretli \"öne çıkar\" seçeneği",
    alanlar: [
      ["Satın Alan", "Ödemeyi yapan kullanıcı; ad ve telefon Users tablosundan eşleştirilir."],
      ["Başlangıç / Bitiş", "Öne çıkarma süresinin başladığı ve bittiği tarih."],
      ["Durum", "Süresi devam ediyorsa Aktif, geçmişse Doldu."],
      ["Aylara Göre Satın Almalar", "Hangi ay kaç satış olduğu ve o ayın tahmini geliri."],
      ["Tahmini Gelir", "Satın alma sayısı × Purchase_Options tablosundaki birim fiyat."],
    ],
    uyari: "Gelir tutarı tek bir birim fiyat üzerinden hesaplanan tahmindir; muhasebe kaydı yerine geçmez.",
  },
};

export default REHBER;
export const sayfaRehberiniGetir = anahtar => REHBER[anahtar] || null;
